import { createContext, useContext, useState } from "react"
import PlanForm from "components/car/PlanForm"
import { CarContext } from "../CarContext"

export const states = Object.freeze({
  FORM: "form",
  LOADING: "loading",
  CRIF: "crif",
  WHATSAPP: "whatsapp",
  DONE: "done",
  FCA: "fca"
})

export const FormContext = createContext({ state: states.FORM })

// eslint-disable-next-line react/prop-types
function FormContextProvider({ children }) {
  const [state, setState] = useState(states.FORM)

  return <FormContext.Provider value={{ state, setState }}>{children}</FormContext.Provider>
}

function Form() {
  const { car, selectedPlan, page, initialData } = useContext(CarContext)

  return (
    <div>
      <FormContextProvider>
        <PlanForm key={car.id} car={car} selectedPlan={selectedPlan} page={page} initialData={initialData} />
      </FormContextProvider>
    </div>
  )
}

export default Form
